module.exports = __webpack_public_path__ + "img/5a0c42c.png";